<template>
  <main class="page-main">
    <page-pop-card />
    <el-divider class="custom-divider"></el-divider>
    <div class="page-main-title">中国中检，打造真正的奢侈品鉴定团队</div>
    <page-search-form />
    <page-tips />
  </main>
</template>
<script>
import PagePopCard from '../../search-page/components/page-pop-card/page-pop-card.vue'
import PageTips from '../page-tips/page-tips.vue'
import PageSearchForm from '../page-search-form/page-search-form.vue'
export default {
  name: 'PageMain',
  components: { PagePopCard, PageTips, PageSearchForm }
}
</script>
<style lang="stylus" scoped src="./page-main.styl"></style>
